import React, { useState, useEffect } from 'react';
import LinkPlus from '../../UI/LinkPlus.js';
import useGetURL from '../../../hooks/useGetURL.js';
import MensajeError from '../../UI/MensajeError.js';
import MensajeCargando from '../../UI/MensajeCargando.js';
import * as TipoItemGeo from '../../constantes/TipoItemGeo.js';
import * as FiltrosURL from '../../constantes/FiltrosURL.js';
import styles from './Geografia.module.css';

const TotalesItemGeo = (props) => {
  const geografia = props.geografia;
  const item = props.item;
  const tipoItem = props.tipo;
  const [totales, setTotales] = useState(null);
  const { isCargando, erroresGet, fetchData, resetErroresGet } = useGetURL();

  let url = '';
  let filtroURL = '';
  switch (tipoItem) {
    case TipoItemGeo.PAIS: {
      url = 'paises/' + item.id + '/totales';
      filtroURL = FiltrosURL.PAIS + '=' + item.id;
      break;
    }
    case TipoItemGeo.PROVINCIA: {
      url = 'provincias/' + item.id + '/totales';
      filtroURL =
        FiltrosURL.PAIS + '=' + geografia.pais.id + '&' + FiltrosURL.PROVINCIA + '=' + item.id;
      break;
    }
    case TipoItemGeo.LOCALIDAD: {
      url = 'localidades/' + item.id + '/totales';
      filtroURL =
        FiltrosURL.PAIS +
        '=' +
        geografia.pais.id +
        '&' +
        FiltrosURL.PROVINCIA +
        '=' +
        geografia.provincia.id +
        '&' +
        FiltrosURL.LOCALIDAD +
        '=' +
        item.id;
      break;
    }
    default: {
      throw new Error('Tipo de item desconocido');
    }
  }

  useEffect(() => {
    if (url === null) {
      setTotales(null);
    } else {
      fetchData(url, setTotales);
    }
  }, [fetchData, url]);

  useEffect(() => {
    // reset any previous errors for this get hook on mount
    resetErroresGet();
  }, [resetErroresGet]);

  return (
    <React.Fragment>
      {item && !isCargando && (
        <div className={`${styles.cuadroTotales}`}>
          {erroresGet === null && totales && (
            <React.Fragment>
              <div className={`${styles.tituloCuadroTotales}`}>Totales {item.nombre}</div>
              <table className={`${styles.tablaDatos}`}>
                <tbody>
                  <tr>
                    <td className={`${styles.totales}`}>
                      <LinkPlus to={'/clubes?' + filtroURL} adaptativo={true}>
                        {totales.clubes}
                      </LinkPlus>
                    </td>
                    <td className={`${styles.valor}`}>
                      club{totales.clubes > 1 && 'es'} cargado
                      {totales.clubes > 1 && 's'}
                    </td>
                  </tr>
                  <tr>
                    <td className={`${styles.totales}`}>
                      <LinkPlus to={'/admin/estadios?' + filtroURL} adaptativo={true}>
                        {totales.estadios}
                      </LinkPlus>
                    </td>
                    <td className={`${styles.valor}`}>
                      estadio{totales.estadios > 1 && 's'} cargado
                      {totales.estadios > 1 && 's'}
                    </td>
                  </tr>
                  <tr>
                    <td className={`${styles.totales}`}>
                      <LinkPlus to={'/arbitros?' + filtroURL} adaptativo={true}>
                        {totales.arbitros}
                      </LinkPlus>
                    </td>
                    <td className={`${styles.valor}`}>
                      árbitro{totales.arbitros > 1 && 's'} nacido
                      {totales.arbitros > 1 && 's'} allí
                    </td>
                  </tr>
                  <tr>
                    <td className={`${styles.totales}`}>
                      <LinkPlus to={'/jugadores?' + filtroURL} adaptativo={true}>
                        {totales.jugadores}
                      </LinkPlus>
                    </td>
                    <td className={`${styles.valor}`}>
                      jugador{totales.jugadores > 1 && 'es'} nacido
                      {totales.jugadores > 1 && 's'} allí
                    </td>
                  </tr>
                  <tr>
                    <td className={`${styles.totales}`}>
                      <LinkPlus to={'/tecnicos?' + filtroURL} adaptativo={true}>
                        {totales.tecnicos}
                      </LinkPlus>
                    </td>
                    <td className={`${styles.valor}`}>
                      técnico{totales.tecnicos > 1 && 's'} nacido
                      {totales.tecnicos > 1 && 's'} allí
                    </td>
                  </tr>
                </tbody>
              </table>
            </React.Fragment>
          )}
          <MensajeError estilo={`${styles.error}`} errores={erroresGet} />
        </div>
      )}
      <MensajeCargando estilo={`${styles.cargando}`} isCargando={isCargando} />
    </React.Fragment>
  );
};

export default TotalesItemGeo;
